import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.title = "Sai Medical";

// Prevent mouse wheel from changing number input values
document.addEventListener('wheel', function(event) {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
});

// Suppress unhandled extension / performance observer errors like startTime
window.addEventListener('error', function(e) {
  if (e?.message?.includes('startTime') || e?.message?.includes('reportAllChanges')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister().then(unregistered => {
        if (unregistered) console.log('Stale SW unregistered successfully');
      });
    }
  });
}

if ('caches' in window) {
  caches.keys().then(names => {
    for (const name of names) {
      caches.delete(name);
    }
  });
}
